import { SubscriptionsUsageStoreState } from '../../types';
import { SubscriptionsUsageMainStoreState } from './types';

export const selectSubscriptionUsage = (
	state: SubscriptionsUsageMainStoreState,
): SubscriptionsUsageStoreState => state.subscriptionsUsage;
